 <nz-row class="page-content-section options-panel">
  <fieldset style="width: 100%">
    

     <legend *ngIf="sectionTitle">{{sectionTitle}}</legend>
    <nz-space nz-col nzSpan="24" style="width: 100%" nzDirection="vertical">
      <div class="add-button" *nzSpaceItem>
        <a nz-button nzType="primary" (click)="addLineToTable()" *isAuthorized="'Admin,Editor'">
          <i nz-icon nzType="plus" nzTheme="outline"></i>{{buttonLabel}} 
        </a>
      </div>
    <nz-table 
       *nzSpaceItem 
      [nzBordered]="true"
      [nzData]="listOfOptions"
      [nzShowPagination]="true"
      [nzShowSizeChanger]="true" 
      [nzTotal]="listOfOptions.length"
      [nzPageIndex]="tableParams.index"
      [nzPageSize]="tableParams.size"
      (nzPageIndexChange)="onPageChange($event)"
       #productsTable
     >
        <thead>
          <tr>
            <th nzWidth="50px" nzLeft>#</th>
            <th>{{'Name' | translate}}</th>
            <th *ngFor="let lang of languages">
              {{ lang.Label }}
            </th>
            <th [nzWidth]="'125px'" style="text-align: center">{{'Is Default' | translate}}</th>
            <th [nzWidth]="'125px'"></th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let data of productsTable.data; let j = index;trackBy: trackByFn">
            <td style="min-width: 50px" nzLeft>
              {{ (tableParams.index - 1) * tableParams.size + (j + 1) }}
            </td>
            <!-- <td style="min-width: 50px" nzLeft> {{ (tableParams.index - 1) * tableParams.size + j + 1 }}</td> -->
            <td>
              <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the option name.' | translate">
                <input nz-input [(ngModel)]="data.Name" [ngModelOptions]="{ standalone: true }" />
              </nz-form-control>
            </td>
              <td *ngFor="let lang of languages">
              <nz-form-control [nzSm]="24" [nzXs]="24" [nzErrorTip]="'Please insert the option name.' | translate" >
                <input nz-input [ngModel]="
                    data.Translations ?? []
                      | ValueFromArray
                        : 'Label'
                        : { name: 'LanguageId', value: +lang.Code }
                  " (ngModelChange)="translationChange(
                    getIndex(j), lang.Code, $event)"
                  [ngModelOptions]="{ standalone: true }" />
              </nz-form-control>
            </td>
            <td style="text-align: center">
              <label nz-checkbox [(ngModel)]="data.IsDefault" (ngModelChange)="defaultOptionChanged($event, data)"
                [ngModelOptions]="{ standalone: true }"></label>
            </td>
            <td style="text-align: center">
              <a *isAuthorized="'Admin,Editor'" nz-button nz-popconfirm
                [nzPopconfirmTitle]="'Are you sure delete this option? please note that all related values in products will be deleted as well' | translate"
                (nzOnConfirm)="deleteOption(getIndex(j))">
                <i class="fal fa-trash"></i> &nbsp;&nbsp; {{'Delete' }}
              </a>
            </td>
          </tr>
        </tbody>
      </nz-table>
    </nz-space>
  </fieldset>
</nz-row> 
<!-- <legend>Attribute Options</legend>-->
